var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIvoryCoastFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 473.681 473.681",
    style: {
      enableBackground: "new 0 0 473.681 473.681"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#008E56"
    },
    d: "M315.8,13.537l-27.64,76.628c25.511,84.197,25.511,209.158,0,293.358l27.639,76.624 c91.975-32.523,157.881-120.201,157.881-223.309C473.682,133.731,407.774,46.057,315.8,13.537z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7E7E7"
    },
    d: "M315.8,90.161V13.537c-24.7-8.736-51.266-13.534-78.961-13.534 C273.359,0.004,222.723,123.772,315.8,90.161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E7E7E7"
    },
    d: "M236.839,473.681c27.695,0,54.261-4.798,78.961-13.534v-76.624 C223.657,374.328,236.839,473.681,236.839,473.681z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E97E24"
    },
    d: "M0.001,236.838c0,103.456,66.355,191.362,158.805,223.623V13.223 C66.356,45.484,0.001,133.391,0.001,236.838z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#14B36F"
    },
    d: "M315.8,90.161v293.358C341.315,299.323,341.315,174.361,315.8,90.161z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F1F2"
    },
    d: "M315.8,383.523V90.161C299.672,36.94,273.356,0,236.839,0c-27.351,0-53.592,4.693-78.034,13.223 v447.238c24.442,8.523,50.682,13.219,78.034,13.219C273.359,473.681,299.674,436.745,315.8,383.523z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIvoryCoastFlag);
export default __webpack_public_path__ + "static/media/ivory-coast-flag.491882d4e01575c24d688f5a8d5560e6.svg";
export { ForwardRef as ReactComponent };